/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Spend_No_DataInputs */



/**
* | output |
* | --- |
* | "No usage yet this period." |
*
* @param {Gateway_Sub_Spend_No_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_spend_no_data = /** @type {((inputs?: Gateway_Sub_Spend_No_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Spend_No_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Nutzung in diesem Zeitraum.")
	return /** @type {LocalizedString} */ ("No usage yet this period.")
});